export const styles = {
    actions: {
        display: 'flex'
    }
};
